import {
  APPLICATION_FUNDING_AMOUNT_ERROR,
  APPLICATION_FUNDING_AMOUNT_SUCCESS,
  APPLICATION_FUNDING_ERROR,
  APPLICATION_FUNDING_SUCCESS,
  BANK_APPLICATION_FUNDING_AMOUNT_ERROR,
  BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  BANK_APPLICATION_FUNDING_ERROR,
  BANK_APPLICATION_FUNDING_SUCCESS,
  DELETE_APPLICATION_FUNDING_SUCCESS,
  DELETE_APPLICATION_FUNDING_ERROR,
} from '../../actions/funding/fundingActionConstants';
import createReducer from '../../utils/createReducer';

const initialState = {
  applicationFunding: {},
  bankApplicationFunding: {},
  error: '',
};

export default createReducer(
  {
    [APPLICATION_FUNDING_SUCCESS]: applicationFundingSuccess,
    [APPLICATION_FUNDING_ERROR]: applicationFundingError,
    [BANK_APPLICATION_FUNDING_SUCCESS]: bankApplicationFundingSuccess,
    [BANK_APPLICATION_FUNDING_ERROR]: bankApplicationFundingError,
    [APPLICATION_FUNDING_AMOUNT_SUCCESS]: applicationFundingAmountSuccess,
    [APPLICATION_FUNDING_AMOUNT_ERROR]: applicationFundingAmountError,
    [BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS]: bankApplicationFundingAmountSuccess,
    [BANK_APPLICATION_FUNDING_AMOUNT_ERROR]: bankApplicationFundingAmountError,
    [DELETE_APPLICATION_FUNDING_SUCCESS]: deleteApplicationFundingSuccess,
    [DELETE_APPLICATION_FUNDING_ERROR]: deleteApplicationFundingError,
  },
  initialState,
);

function applicationFundingSuccess(state, action) {
  return {
    ...state,
    applicationFunding: action.payload,
    error: '',
  };
}

function applicationFundingError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function bankApplicationFundingSuccess(state, action) {
  return {
    ...state,
    bankApplicationFunding: action.payload,
    error: '',
  };
}

function bankApplicationFundingError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function applicationFundingAmountSuccess(state) {
  return {
    ...state,
    error: '',
  };
}

function deleteApplicationFundingSuccess(state) {
  return {
    ...state,
    error: '',
  };
}

function deleteApplicationFundingError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function applicationFundingAmountError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}

function bankApplicationFundingAmountSuccess(state) {
  return {
    ...state,
    error: '',
  };
}

function bankApplicationFundingAmountError(state, action) {
  return {
    ...state,
    error: action.payload,
  };
}
